import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { RemoveLikeGoodsParams } from './types';

/**
 * - 최근 본 상품의 찜 제거
 */
export const removeLikeGoods = ({
  list_params_referrer,
  sno,
}: RemoveLikeGoodsParams) => {
  return defaultHttpClient.request<{
    goods_sno: number;
    likes_count: number;
    like: {
      goods_sno: number;
      created_at: string;
      folder_sno: number | null;
    } | null;
  }>({
    method: 'DELETE',
    url: `/api/v2/goods/${sno}/like`,
    data: {
      list_id_referrer: 'recently_viewed_list',
      list_params_referrer,
    },
  });
};
